export default __webpack_public_path__ + "static/media/breakfast-overlay@3x.7c69375c.png";